import script from "./CustomerService.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerService.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=807f233e&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__